var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.screen > 800)?_c('v-app-bar',{class:_vm.navVar,staticStyle:{"height":"200px"}},[_c('v-spacer')],1):_c('v-app-bar',{class:_vm.navVar,staticStyle:{"height":"46.5vw"}},[_c('v-spacer')],1),_c('v-main',[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }